import { Badge } from '@/shared/components/ui/badge'

interface UserStatusBadgeProps {
  isActive: boolean
}

export function UserStatusBadge({ isActive }: UserStatusBadgeProps) {
  return isActive ? (
    <Badge variant="active">Activo</Badge>
  ) : (
    <Badge variant="cancelled">Inactivo</Badge>
  )
}
